import React from 'react';
import PropTypes from 'prop-types';

import './InlineTextareaField.less';

class InlineTextareaField extends React.Component {
  constructor(props) {
    super(props);
    this.focusInput = this.focusInput.bind(this);
  }

  focusInput() {
    this.textarea.focus();
  }

  render() {
    const { input, style, rows } = this.props;
    return (
      <textarea
        {...input}
        ref={el => {
          this.textarea = el;
        }}
        className="inline-textarea-field"
        style={{ ...style, whiteSpace: 'pre' }}
        rows={rows}
        spellCheck="false"
      />
    );
  }
}

InlineTextareaField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  // wrap: PropTypes.string,
  style: PropTypes.shape({}),
  rows: PropTypes.number,
};

export default InlineTextareaField;
